import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { getContractApiUrl } from '../utils/apiUrls';

const BACKEND_URL = getContractApiUrl();
const INKLESS_BASE = (BACKEND_URL.endsWith('/contract')
  ? BACKEND_URL.slice(0, -'/contract'.length)
  : BACKEND_URL.replace(/\/contract\/?$/, '')) + '/inkless';

const box = { maxWidth: 480, margin: '80px auto', padding: 24, textAlign: 'center' };

const SigningInvite = () => {
  const { token } = useParams();
  const [message, setMessage] = useState('Opening your signing page…');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${INKLESS_BASE}/signing-invite/${encodeURIComponent(token)}`);
        if (cancelled) return;
        const status = res.data?.status;
        const signingUrl = res.data?.signing_url;
        if (status === 'completed') {
          setMessage('You have already completed signing. You may close this window.');
          return;
        }
        if (status === 'rejected') {
          setMessage('This signing request is no longer available.');
          return;
        }
        if (status === 'expired') {
          setMessage('This signing link has expired.');
          return;
        }
        if (signingUrl) {
          window.location.replace(signingUrl);
          return;
        }
        setMessage('This signing link is no longer available.');
      } catch {
        if (!cancelled) {
          setMessage('This signing link is invalid or has expired.');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div style={box}>
      <h1 style={{ fontSize: 22, marginBottom: 12 }}>E-sign</h1>
      <p style={{ color: '#374151', fontSize: 16 }}>{message}</p>
    </div>
  );
};

export default SigningInvite;
